module.exports = __webpack_public_path__ + "static/media/insights-img-1.94c5edbd.png";